import React from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

import styles from './styles.scss';

export const CountrySelectionButton = ({ country, onButtonClick, intl }) => {
    const onClick = () => onButtonClick(country, intl.formatMessage({ id: 'successMessage' }));

    return (
        <div styleName="button" onClick={onClick}>
            <div styleName={`icon-flag ${country.icon}`} />
            <div styleName="country-name">{country.name}</div>
        </div>
    );
};

CountrySelectionButton.propTypes = {
    onButtonClick: PropTypes.func.isRequired,
    country: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
};

export const injectStyles = component => CSSModules(component, styles, { allowMultiple: true });

export default compose(
    injectIntl,
    injectStyles
)(CountrySelectionButton);
